import { put, fork, take, takeLatest } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { firestoreRef } from '../utils/firebase';
import { fetchTemplates, TemplatesActions, fetchSingleTemplateReturn } from '../actions/templates.actions';

export const getEmptyTemplateConf = templateName => {
    switch (templateName) {
        case 'Default':
            return {
                header: [],
                content: [],
                footer: []
            };
        case 'Double':
            return {
                header: [],
                colLeft: [],
                colRight: [],
                footer: []
            };
        case 'Triple':
            return {
                header: [],
                colLeft: [],
                colCenter: [],
                colRight: [],
                footer: []
            };
        case 'Quadruple':
            return {
                header: [],
                colLeft: [],
                colCenterLeft: [],
                colCenterRight: [],
                colRight: [],
                footer: []
            };
        case 'TwoThird':
            return {
                header: [],
                colLeft: [],
                colRight: [],
                footer: []
            };
        default:
            break;
    }
};

function* startListener() {
    const channel = new eventChannel(emitter => {
        const listener = firestoreRef.collection('templates').onSnapshot(snapshot => {
            const docs = [];
            snapshot.forEach(doc => {
                docs.push(doc.id);
            });
            emitter({ data: docs || [] });
        });

        return () => {
            listener.off();
        };
    });

    while (true) {
        const { data } = yield take(channel);
        yield put(fetchTemplates(data));
    }
}

function* fetchSingleTemplateSaga(action) {
    const templateName = action.payload;
    const channel = new eventChannel(emitter => {
        const listener = firestoreRef
            .collection('templates')
            .doc(templateName)
            .get()
            .then(doc => {
                emitter({ data: { ...doc.data(), id: doc.id } || {} });
            });

        return () => {
            listener.off();
        };
    });

    while (true) {
        const { data } = yield take(channel);
        yield put(fetchSingleTemplateReturn(data));
    }
}

export function* templatesSaga() {
    yield fork(startListener);
    yield takeLatest(TemplatesActions.FETCH_SINGLE_TEMPLATE, fetchSingleTemplateSaga);
}
